import type { CSSProperties } from "react";

// Selected list-row style for the med-spa template/form pickers, mirroring the
// card-on-file "default" look (PaymentMethodCard.module.css): a soft brand-teal
// fill + teal border. Unselected rows keep a transparent 1px border so picking
// a row doesn't shift the layout, plus the usual gray bottom separator.
export function selectedRowStyle(isSelected: boolean): CSSProperties {
  return {
    cursor: "pointer",
    background: isSelected ? "rgba(54, 175, 201, 0.09)" : "transparent",
    border: isSelected
      ? "1px solid rgba(54, 175, 201, 0.5)"
      : "1px solid transparent",
    borderBottom: isSelected
      ? "1px solid rgba(54, 175, 201, 0.5)"
      : "1px solid var(--mantine-color-gray-2)",
    borderRadius: isSelected ? "var(--mantine-radius-md)" : 0,
  };
}
